import { ControlState, CplaceMultiSelectControlChange, CplaceMultiSelectControlParameters, Option } from '../../api/model/models';
import { ControlChangeHandler } from '../../controls';
import { mockControlIdentity, mockControlStateSharedData } from './controls.shared';

export const mockCplaceMultiSelectControlOptions: Option[] = generateMockCplaceMultiSelectControlOptions(50);

export function generateMockCplaceMultiSelectControlOptions(amount: number): Option[] {
  const options: Option[] = [];
  for (let i = 0; i < amount; i++) {
    options.push({
      label: 'Option ' + i,
      value: i.toString(),
      icon: 'fa fa-coffee',
    });
  }
  return options;
}

export const mockCplaceMultiSelectControlControlParams: CplaceMultiSelectControlParameters = {
  componentName: 'CplaceMultiSelectControlComponent',
  value: [mockCplaceMultiSelectControlOptions[0].value],
  options: mockCplaceMultiSelectControlOptions,
};

export const mockCplaceMultiSelectControlControlState: ControlState = {
  ...mockControlStateSharedData,
  identity: mockControlIdentity,
  controlParameters: mockCplaceMultiSelectControlControlParams,
};

export const mockCplaceMultiSelectControlChangeHandler: ControlChangeHandler<
  CplaceMultiSelectControlChange,
  CplaceMultiSelectControlParameters
> = (controlParameters, controlChange) => {
  return {
    ...controlParameters,
    value: controlChange.value,
  };
};
